import { useContext, useEffect } from 'react'
import { ErrorModalContext } from '../../context/errorModalContext'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { AxiosErrorData } from '../../types/api'
export const handleApiErros = (
  error: AxiosErrorData,
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>,
  navigate: NavigateFunction,
) => {
  if (error?.response) {
    const statusCode = error.response.status
    if (statusCode >= 500) {
      setShowModal(true)
      setErrorMessage('Erreur du serveur')
    }
    if (statusCode === 403) {
      navigate('/forbidden')
    } else {
      setShowModal(true)
      if (error.response?.data?.message) {
        let errorMessage = error.response.data.message
        try {
          const parsedMessage = JSON.parse(errorMessage)
          if (parsedMessage.error) {
            errorMessage = parsedMessage.error
          }
        } catch (e) {
          try {
            errorMessage = JSON.parse(`"${errorMessage}"`)
          } catch (e2) {
            errorMessage = errorMessage.replace(/\\u[\dA-F]{4}/gi, (match) => {
              return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
            })
          }
        }
        
        setErrorMessage(errorMessage)
      } else {
        setErrorMessage('Erreur du serveur')
      }
    }
  }
}
const useHandleError = (error: any) => {
  const { setShowModal, setErrorMessage } = useContext(ErrorModalContext)
  const navigate = useNavigate()
  useEffect(() => {
    handleApiErros(error, setShowModal, setErrorMessage, navigate)
  }, [error])
}

export default useHandleError
